import React from "react";
import { connect } from "react-redux";
import { path } from "ramda";
import { ReducerKeys } from "../../reducers/index";
import SettingReducer from "../../reducers/SettingReducer";
import { ReportUtil } from "../../util/index";

const state2props = (state)=>{
	const reportDate = path([ReducerKeys.SETTING, "reportDate"], state);
	return { reportDate };
};
const mapDispatch = dispatch=>({
	setReportDate: reportDate=> dispatch(SettingReducer.setReportDate(reportDate))
});

export default (Comp)=>{
	const withCompareDate = (props)=>{
		const { setReportDate } = props;
		const saveDateRange = (type, range)=>{
			const { reportDate } = props;
			reportDate[type] = range;
			setReportDate(ReportUtil.createSaveCompareDate(reportDate));
		};
		const getMomentReportDate = ()=>{
			const { reportDate } = props;
			return ReportUtil.toMomentCompareDate(reportDate);
		};
		const getMomentDateFromType = (type)=>getMomentReportDate()[type];
		return <Comp {...props}
			saveDateRange={saveDateRange} 
			getMomentReportDate={getMomentReportDate} 
			getMomentDateFromType={getMomentDateFromType}
		/>;
	};
	return connect(state2props, mapDispatch)(withCompareDate);
};


// WEBPACK FOOTER //
// ./src/hoc/with/withCompareDate.js